export enum MatchStatus {
  PLAYED = 1,
  NOT_STARTED = 2,
  FIRST_HALF = 8,
  HALF_TIME = 9,
  SECOND_HALF = 10,
  FIRST_HALF_EXTRA_TIME = 11,
  SECOND_HALF_EXTRA_TIME = 12,
  PENALTIES = 13,
  PAUSE_BEFORE_EXTRA_TIME = 14,
  HALF_TIME_EXTRA_TIME = 15,
}

export const noTimeMatchStatuses: MatchStatus[] = [
  MatchStatus.PLAYED,
  MatchStatus.NOT_STARTED,
  MatchStatus.HALF_TIME,
  MatchStatus.PAUSE_BEFORE_EXTRA_TIME,
  MatchStatus.HALF_TIME_EXTRA_TIME,
];
